import { Contract, ContractStatusMap } from 'shared/models/contract';
import { BadgeThemeKeys } from 'theme/components/Badge';

type contractStatusLabels = 'Cancelado' | 'Desativado' | 'Ativo';

interface BadgeRenderData {
  badgeVariant: BadgeThemeKeys;
  dotColor?: string;
  label: contractStatusLabels | '';
  status?: ContractStatusMap;
}
const badgeVariantMap: Map<string, BadgeRenderData> = new Map();
badgeVariantMap.set('empty', {
  badgeVariant: BadgeThemeKeys.YOOGA_GRAY,
  dotColor: 'yGray.800',
  label: '',
});
badgeVariantMap.set('canceled', {
  badgeVariant: BadgeThemeKeys.YOOGA_RED,
  dotColor: 'yRed.800',
  label: 'Cancelado',
  status: ContractStatusMap.CANCELED,
});
badgeVariantMap.set('deactivated', {
  badgeVariant: BadgeThemeKeys.YOOGA_GRAY,
  dotColor: 'yGray.800',
  label: 'Desativado',
  status: ContractStatusMap.DEACTIVATED,
});
badgeVariantMap.set('active', {
  badgeVariant: BadgeThemeKeys.YOOGA_GREEN,
  dotColor: 'yGreen.800',
  label: 'Ativo',
  status: ContractStatusMap.ACTIVE,
});

export const getBadgeVariant = (contract: Contract): BadgeRenderData => {
  let badgeVariant = badgeVariantMap.get('empty')!;
  badgeVariantMap.forEach((variant) => {
    if (contract.statusTag === variant.status) {
      badgeVariant = variant;
    }
  });
  return badgeVariant;
};
